import { ANNOUNCEMENT_STEPS } from '../helpers/announcementSteps';
import {
  StepBarRow,
  StepColumn,
  StepLabel,
  StepTrack,
} from './AnnouncementStepBar.styled';

type Props = {
  /** Index of the step being edited, from `AnnouncementStep`. */
  current: number;
  /** Called with the step index when a visited step is clicked. */
  onStepClick: (step: number) => void;
};

/**
 * Steps behind the current one are clickable - going back to fix a typo
 * should not cost three presses of Back. Steps ahead are not: the way
 * forward runs through `goNext`, which is where validation lives.
 */
export const AnnouncementStepBar = ({ current, onStepClick }: Props) => (
  <StepBarRow>
    {ANNOUNCEMENT_STEPS.map((label, index) => (
      <StepColumn
        key={label}
        $clickable={index < current}
        onClick={index < current ? () => onStepClick(index) : undefined}
      >
        <StepTrack $active={index === current} $done={index < current} />
        <StepLabel $active={index === current}>{label}</StepLabel>
      </StepColumn>
    ))}
  </StepBarRow>
);
